"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convert24HourTo12Hour = void 0;
/**
 * Converts a 24-hour value into it's equivalent 12-hour value.
 * @hidden
 * @param value The 24-hour value.
 * @returns The equivalent 12-hour value.
 */
var convert24HourTo12Hour = function (value) {
    if (value === 0)
        return 12;
    else if (value > 12)
        return value % 12;
    return value;
};
exports.convert24HourTo12Hour = convert24HourTo12Hour;
//# sourceMappingURL=convert-24-hour-to-12-hour.js.map